<template>
  <section class="f-62" ref="root" id="newborn">
    <div class="alive_content">
      <div class="title f-center-title">无限可能，AI 广场等你探索</div>
      <m-img
        class="f-select-center img"
        src="@/v2/auto/assets/image/62/14.png"
      />
      <div class="bg" ref="bg">
        <m-img
          class="img_bg"
          ref="img_bg"
          src="@/v2/auto/assets/image/62/bg.png"
        />
        <Slogan class="slogan" ref="slogan" />
      </div>
    </div>
  </section>
</template>

<script>
import { newbornScroll } from '@/v2/auto/bus_key'
import replay from '@/components/replay.vue'
import Slogan from '@/v2/auto/assets/image/62/slogan.vue'
export default {
  name: 'Assistant',
  components: {
    replay,
    Slogan,
  },
  data() {
    return {
      preload_: true,
      activeIndex: 0,
    }
  },
  mounted() {
    const { root, bg, img_bg, slogan } = this.$refs
    const tl = this.$gsap.timeline({
      scrollTrigger: {
        trigger: bg,
        start: 'top top',
        end: 'bottom bottom',
        pin: true,
        scrub: 1,
      },
    })
    tl.to(img_bg, {})
    tl.addLabel('stop')
    // 背景显现
    tl.to(
      img_bg,
      {
        opacity: 1,
      },
      'stop',
    )
    // slogan文字显现
    tl.to(
      slogan.$el,
      {
        delay: 0.3,
        opacity: 1,
        ease: 'power4.in',
        scale: 0.5,
      },
      'stop',
    )
    tl.addLabel('showSlogan')
    // slogan 放大
    tl.to(
      slogan.$el,
      {
        scale: 3,
      },
      'showSlogan',
    )
    // 背景 放大
    tl.to(
      img_bg,
      {
        ease: 'power4.out',
        opacity: 0,
        scale: 2,
      },
      'showSlogan',
    )
    // 背景渐隐
    tl.to(
      root,
      {
        opacity: 0,
        ease: 'power2.out',
      },
      'showSlogan',
    )
    this.$event.on(newbornScroll, () => {
      const position = tl.scrollTrigger.labelToScroll('showSlogan')
      window.scrollTo({
        top: position,
        behavior: 'instant',
      })
    })
  },
}
</script>

<style lang="less" scoped>
.f-62 {
  position: sticky;
  z-index: 79;
  width: 100%;
  overflow: hidden;
  height: 4350px;
  margin-top: -5px;
  background-color: #000;
}

.alive_content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  .img {
    height: auto;
  }
  .bg {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 3900px;
    .img_bg {
      opacity: 0.4;
      width: 100%;
      height: 100vh;
      object-fit: contain;
      object-position: center;
      transform-origin: 55% 45%;
    }
    .slogan {
      position: absolute;
      top: 0;
      z-index: 1;
      width: 100%;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
      opacity: 0;
      transform: scale(0.2);
    }
  }

  .title {
    font-weight: 700;
    text-align: center;
    background: radial-gradient(
      131.96% 70.14% at 50% 18.06%,
      #eadaff 0%,
      #ffffff 100%
    );
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    margin-bottom: 50px;
  }
}
</style>
